import { Component, inject, input, signal } from "@angular/core";
import { takeUntilDestroyed, toObservable } from "@angular/core/rxjs-interop";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_BUTTON } from "@progress/kendo-angular-buttons";
import { KENDO_DIALOG } from "@progress/kendo-angular-dialog";
import { KENDO_LOADER } from "@progress/kendo-angular-indicators";
import { Subject, catchError, merge, of, switchMap, tap } from "rxjs";
import { FlightImage } from "../models/flight-image.model";
import { Flights2Service } from "../flights2.service";
import { ZonedDateTimePipe } from "../flights2.pipes";

@Component({
    selector: "app-flight-images",
    imports: [TranslatePipe, KENDO_BUTTON, KENDO_DIALOG, KENDO_LOADER, ZonedDateTimePipe],
    templateUrl: "./flight-images.component.html",
    styleUrl: "./flight-images.component.scss",
})
export class FlightImagesComponent {
    private readonly flights = inject(Flights2Service);

    readonly flightId = input.required<number>();
    readonly timeZone = input.required<string>();

    readonly images = signal<FlightImage[]>([]);
    readonly loading = signal(false);
    readonly failed = signal(false);
    readonly opened = signal<FlightImage | null>(null);

    private readonly reload = new Subject<void>();

    constructor() {
        merge(toObservable(this.flightId), this.reload)
            .pipe(
                tap(() => {
                    this.loading.set(true);
                    this.failed.set(false);
                }),
                switchMap(() => this.flights.images(this.flightId()).pipe(catchError(() => of(null)))),
                takeUntilDestroyed(),
            )
            .subscribe((images) => {
                this.loading.set(false);
                this.failed.set(images === null);
                this.images.set(images ?? []);
            });
    }

    load(): void {
        this.reload.next();
    }
}
